import * as React from 'react';
import { Button, Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { flow } from 'lodash';
import { FaCog } from 'react-icons/fa';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import PasswordInput from '../../../../../../components/PasswordInput';
import DefinitionPopup from '../../../../../../components/DefinitionPopup';
import { isRequired } from '../../../../../../util/validators';

interface ILoginFormProps extends InjectedFormProps {
  actions: {
    push: (route: string) => void;
  };
  maxAttempt: boolean;
}

class LoginForm extends React.Component<ILoginFormProps> {
  private preventEvent = (event: any) => {
    event.preventDefault();
  }

  private handleGoResetPassword = () => {
    const { actions } = this.props;
    actions.push('/auth/remind');
  }
  private handleGoRegister = () => {
    const { actions } = this.props;
    actions.push('/auth/create-an-account');
  }

  public render() {
    const { handleSubmit, submitting, maxAttempt, valid } = this.props;

    return (
      <div>
        <p className="mt-10" style={{ padding: '15px' }}>
          Please note, your details here are specific to Travel Insurance.
          Please sign in using the email you entered when you purchased your Travel Insurance policy.
          This could be different to a motor or household policy you have with Admiral.
        </p>
        <Form horizontal={true} onSubmit={handleSubmit} method="post" autoComplete="off">
          <div>

            {/* Email */}
            <div style={{ padding: '0 15px 0 15px' }}>
              <FormGroup controlId="email">
                <Col componentClass={ControlLabel} sm={6} onClick={this.preventEvent}>
                  Email
                  <DefinitionPopup
                    iconStyle={{ color: '#0045A0' }}
                    name="login-email"
                    definition="This is the email that you entered when you purchased your
                                        Travel Insurance policy"/>
                </Col>
                <Col sm={6}>
                  <Field
                    id="email"
                    name="email"
                    type="email"
                    component={FieldFormControl}
                    validate={[isRequired]}
                    tabIndex={1}
                  />
                </Col>
              </FormGroup>
            </div>
            {/* Email END */}

            <hr className="blue-divider"/>

            {/* Password */}
            <div>
              <FormGroup controlId="password" style={{ padding: '0 15px 0 15px' }}>
                <Col componentClass={ControlLabel} sm={6} onClick={this.preventEvent}>
                  Password
                  <DefinitionPopup
                    iconStyle={{ color: '#0045A0' }}
                    name="login-Password"
                    definition="This is the password you enter to setup your Travel Insurance
                                        account. It should be a minimum of 10 characters, with at least one lower case,
                                        one upper case, one number and one of these special characters !@#$%?"/>
                </Col>
                <Col sm={6}>
                  <Field
                    id="password"
                    name="password"
                    type="Password"
                    component={PasswordInput}
                    validate={[isRequired]}
                    tabIndex={2}
                  />
                </Col>
              </FormGroup>
            </div>
            {/* Password END */}

            {/* Max Attempts reached */}
            {maxAttempt && (
              <div className="blue-section">
                <p>Sorry, it looks like too many login attempts have been made. We have emailed you a link to reset your
                  password.</p>
                <p>If you don’t receive the email within 5 minutes, please check your Junk folder.</p>
                <p>Note: the link in the email will expire in 24 hours.</p>
              </div>
            )}

            {/* SIGN IN */}
            {!maxAttempt && (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '15px 15px 0 15px' }}>
                <Button
                  bsStyle="primary"
                  type="submit"
                  bsSize="small"
                  className="secondary-button login-button-main"
                  disabled={submitting || !valid}
                >
                  {submitting ? <FaCog className="fa-spin"/> : 'SIGN IN'}
                </Button>
              </div>
            )}

            <hr className="blue-divider"/>

            {/* Reset & Register */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0 15px 15px 15px'
            }}>
              {/* Register */}
              {!maxAttempt && (
                <Button
                  onClick={this.handleGoRegister}
                  bsStyle="primary"
                  type="submit"
                  bsSize="small"
                  className="secondary-button login-button-sub"
                  disabled={submitting}
                >
                  Not yet registered?
                </Button>
              )}
              {/* Reset password */}
              <Button
                onClick={this.handleGoResetPassword}
                bsStyle="primary"
                type="submit"
                bsSize="small"
                className="secondary-button login-button-sub"
                disabled={submitting}
              >
                Forgotten Password?
              </Button>
            </div>

          </div>

        </Form>
      </div>
    );
  }
}

export default flow([
  reduxForm({
    form: 'login',
  }),
  connect(null,
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(LoginForm);
